import clsx from 'clsx'

/**
 * Un número de resumen: el título, la cifra y qué significa.
 *
 * Estaba escrito CINCO veces —ventas, fiado, merma, compras y reportes—, con
 * el mismo markup y tres tamaños de fuente distintos. Es presentación y no
 * plata, así que la divergencia no rompía ninguna cuenta, pero es la razón por
 * la que arreglar el panel de un reporte en el teléfono no arreglaba los otros
 * cuatro; y es el mismo criterio que ya está escrito para los atajos de rango
 * de fechas.
 *
 * El tamaño de la cifra es RESPONSIVO porque estos paneles van de dos en dos
 * en un teléfono: con 22 px fijos, «$1.529.307,50» se partía en dos renglones
 * en una columna de 170 px.
 */
export function Cifra({
  titulo,
  valor,
  detalle,
  alerta,
}: {
  titulo: string
  valor: string

  // Opcional: hay cifras que se explican solas («Faltó $3.000» abajo de un
  // panel que dice «Cómo cerraron las cajas»), y un renglón de ayuda que
  // repite el título es ruido.
  detalle?: string

  /** La pinta en rojo: es una cifra que hay que mirar (merma, anuladas). */
  alerta?: boolean
}) {
  return (
    <div className="carta px-3 py-2.5 sm:px-4 sm:py-3">
      <p className="text-[12.5px] font-medium text-tinta-tenue">{titulo}</p>

      <p
        className={clsx(
          'num mt-0.5 text-[19px] font-bold tracking-[-0.02em] sm:text-[22px]',
          alerta ? 'text-rojo' : 'text-tinta',
        )}
      >
        {valor}
      </p>

      <p className="text-[12px] leading-snug text-tinta-tenue">{detalle}</p>
    </div>
  )
}
